import { useMutation, useQueryClient } from "@tanstack/react-query";
import { aplicaTargetareSnapshot } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useAplicaTargetareSnapshot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: aplicaTargetareSnapshot,
    onSuccess: (_response, cerere) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.snapshoturi(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.snapshotDiferente(cerere.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.snapshotJob(cerere.id),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
